export const normalizeExternalUrl = (url: string) => {
  const cleanUrl = url.trim();
  if (/^https?:\/\//i.test(cleanUrl)) return cleanUrl;
  return `https://${cleanUrl}`;
};

export const openExternalLink = (url: string) => {
  const cleanUrl = normalizeExternalUrl(url);
  const newWindow = window.open("about:blank", "_blank");

  if (newWindow) {
    newWindow.opener = null;
    newWindow.location.href = cleanUrl;
    return;
  }

  window.location.assign(cleanUrl);
};